/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Vekn_Locked_HintInputs */



/**
* | output |
* | --- |
* | "Locked — this event is already published on the VEKN calendar." |
*
* @param {Tfield_Vekn_Locked_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_vekn_locked_hint = /** @type {((inputs?: Tfield_Vekn_Locked_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Vekn_Locked_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouillé — cet événement est déjà publié sur le calendrier VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueado — este evento ya está publicado en el calendario VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Bloqueado — este evento já está publicado no calendário VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccato — questo evento è già pubblicato nel calendario VEKN.")
	return /** @type {LocalizedString} */ ("Locked — this event is already published on the VEKN calendar.")
});